"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/aboutusSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutusSection54sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-xl-5 col-lg-4" | "col-xl-7 col-lg-8" */
    className: string;
    /** Detected variants: "About Us" | "With over a decade of experience, we've helped hundreds of individuals, couples, and families navigate life's challenges and achieve lasting positive change." */
    div0Text: ReactNode;
    /** Detected variants: "section-sub-title" | "section-title" */
    div0ClassName: string;
    /** Detected variants: "section-header-fifteen" */
    div0ClassName2?: string;
};

type AboutusSectionAvatarAvatarRoundedsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/users/user-sm-1.jpg" | "/Templates/Doccure/img/users/user-sm-2.jpg" | "/Templates/Doccure/img/users/user-sm-3.jpg" | "/Templates/Doccure/img/users/user-sm-4.jpg" */
    src: string;
    /** Detected variants: "avatar avatar-rounded" */
    className?: string;
    /** Detected variants: "img" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
};
export type HomeFifteenAboutusSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    /** Default: "2s" */
    divDiv0Div0DivDataWowDuration?: string;
    divDiv0Div0Div0ClassName?: string;
    /** Default: "about" */
    divDiv0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-img-two.png" */
    divDiv0Div0ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "2s" */
    divDiv0Div1Div0DivDataAosDuration?: string;
    /** Default: "" */
    divDiv0Div1Div0Link0LinkDataFancybox?: string;
    /** Default: "#" */
    divDiv0Div1Div0Link0LinkHref?: string;
    divDiv0Div1Div0Link0LinkVisible?: boolean;
    divDiv0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: " Play Video  · Play Video · " */
    divDiv0Div1Div0Link0Div0DivDataText?: string;
    /** Default: "2s" */
    divDiv0Div1Div1DivDataWowDuration?: string;
    /** Default: "More then 4.9K has" */
    divDiv0Div1Div1P0PText?: ReactNode;
    /** Default: "been treated so far" */
    divDiv0Div1Div1P0PText2?: ReactNode;
    /** Default: "about" */
    divDiv0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-bg-img.jpg" */
    divDiv0Div1ImageWithBasePath0ImageSrc?: string;
    divDiv0Div1ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "line" */
    divImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/line-bg.png" */
    divImageWithBasePath0ImageSrc?: string;
    divImageWithBasePath0ImageVisible?: boolean;
    divImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutusSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutusSection54s: AboutusSection54sItem[];
    aboutusSectionAvatarAvatarRoundeds: AboutusSectionAvatarAvatarRoundedsItem[];
    aboutusSection54sItemWrapper?: (item: AboutusSection54sItem, content: ReactNode) => ReactNode;
    aboutusSection54sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutusSectionAvatarAvatarRoundedsItemWrapper?: (item: AboutusSectionAvatarAvatarRoundedsItem, content: ReactNode) => ReactNode;
    aboutusSectionAvatarAvatarRoundedsRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutusSectionAvatarAvatarRoundedsImageVisible?: boolean;
    aboutusSectionAvatarAvatarRoundedsImageRenderer?: (item: AboutusSectionAvatarAvatarRoundedsItem, defaultNode: ReactNode) => ReactNode;
    aboutusSectionAvatarAvatarRoundedsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutusSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeFifteenAboutusSectionGenerated: FC<HomeFifteenAboutusSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    divDiv0Div0DivDataWowDuration = "2s",
    divDiv0Div0ImageWithBasePath0ImageAlt = "about",
    divDiv0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/about-img-two.png",
    divDiv0Div0ImageWithBasePath0ImageVisible,
    divDiv0Div0ImageWithBasePath0ImageRenderer,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0DivDataAosDuration = "2s",
    divDiv0Div1Div0Link0Div0DivDataText = " Play Video  · Play Video · ",
    divDiv0Div1Div0Link0LinkDataFancybox = "",
    divDiv0Div1Div0Link0LinkHref = "#",
    divDiv0Div1Div0Link0LinkVisible,
    divDiv0Div1Div0Link0LinkRenderer,
    divDiv0Div1Div0Link0LinkProps,
    divDiv0Div1Div1DivDataWowDuration = "2s",
    divDiv0Div1Div1P0PText = "More then 4.9K has",
    divDiv0Div1Div1P0PText2 = "been treated so far",
    divDiv0Div1ImageWithBasePath0ImageAlt = "about",
    divDiv0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-bg-img.jpg",
    divDiv0Div1ImageWithBasePath0ImageVisible,
    divDiv0Div1ImageWithBasePath0ImageRenderer,
    divDiv0Div1ImageWithBasePath0ImageProps,
    divImageWithBasePath0ImageAlt = "line",
    divImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/line-bg.png",
    divImageWithBasePath0ImageVisible,
    divImageWithBasePath0ImageRenderer,
    divImageWithBasePath0ImageProps,
    spanImageWithBasePath0ImageProps,
    divDiv0Div0Div0ClassName,
    aboutusSection54s,
    aboutusSectionAvatarAvatarRoundeds,
    aboutusSection54sItemWrapper,
    aboutusSection54sRenderer,
    aboutusSectionAvatarAvatarRoundedsItemWrapper,
    aboutusSectionAvatarAvatarRoundedsRenderer,
    aboutusSectionAvatarAvatarRoundedsImageVisible,
    aboutusSectionAvatarAvatarRoundedsImageRenderer,
    aboutusSectionAvatarAvatarRoundedsImageProps,
}) => {
    return (
        <>
            <div className="section about-section-fifteen">
                <div className="container">
                    <div className="about-head wow fadeInUp" data-wow-duration={divDiv0Div0DivDataWowDuration}>
                        <div className={divDiv0Div0Div0ClassName ?? "row"}>
                            {renderCollectionNode(
                                aboutusSection54s,
                                (item: AboutusSection54sItem) => (
                                    <div className={item.className} key={item.key}>
                                        <div className={item.div0ClassName2 ?? "section-header-fifteen"}>
                                            <div className={item.div0ClassName}>{item.div0Text}</div>
                                        </div>
                                    </div>
                                ),
                                aboutusSection54sItemWrapper,
                                aboutusSection54sRenderer
                            )}
                        </div>
                        {renderNode(divDiv0Div0ImageWithBasePath0ImageVisible, divDiv0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={divDiv0Div0ImageWithBasePath0ImageSrc} alt={divDiv0Div0ImageWithBasePath0ImageAlt} className="img-fluid element-1" {...(divDiv0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                    </div>
                    <div className="about-video-fifteen">
                        {renderNode(divDiv0Div1ImageWithBasePath0ImageVisible, divDiv0Div1ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={divDiv0Div1ImageWithBasePath0ImageSrc} alt={divDiv0Div1ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(divDiv0Div1ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        <div className="video-btn wow fadeInUp" data-aos-duration={divDiv0Div1Div0DivDataAosDuration}>
                            {renderNode(divDiv0Div1Div0Link0LinkVisible, divDiv0Div1Div0Link0LinkRenderer, (
                                <SmartLink href={divDiv0Div1Div0Link0LinkHref} data-fancybox={divDiv0Div1Div0Link0LinkDataFancybox} {...(divDiv0Div1Div0Link0LinkProps ?? {})}>
                                    <div className="animate-button2" data-text={divDiv0Div1Div0Link0Div0DivDataText}>
                                        <span className="button-text2" />
                                        <span className="button-circle">
                                            <i className="isax isax-play" />
                                        </span>
                                    </div>
                                </SmartLink>
                            ))}
                        </div>
                        <div className="about-user wow fadeInUp" data-wow-duration={divDiv0Div1Div1DivDataWowDuration}>
                            <div className="avatar-list-stacked avatar-group-lg">
                                {renderCollectionNode(
                                    aboutusSectionAvatarAvatarRoundeds,
                                    (item: AboutusSectionAvatarAvatarRoundedsItem) => (
                                        <span className={item.className ?? "avatar avatar-rounded"} key={item.key}>
                                            {renderItemNode(aboutusSectionAvatarAvatarRoundedsImageVisible, aboutusSectionAvatarAvatarRoundedsImageRenderer, item, (
                                                <SmartImage className={item.imageWithBasePath0ClassName ?? "img-fluid"} src={item.src} alt={item.alt ?? "img"} {...(typeof aboutusSectionAvatarAvatarRoundedsImageProps === "function" ? aboutusSectionAvatarAvatarRoundedsImageProps(item) : (aboutusSectionAvatarAvatarRoundedsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </span>
                                    ),
                                    aboutusSectionAvatarAvatarRoundedsItemWrapper,
                                    aboutusSectionAvatarAvatarRoundedsRenderer
                                )}
                            </div>
                            <p>
                                {divDiv0Div1Div1P0PText}
                                <br />
                                {divDiv0Div1Div1P0PText2}
                            </p>
                        </div>
                    </div>
                </div>
                {renderNode(divImageWithBasePath0ImageVisible, divImageWithBasePath0ImageRenderer, (
                    <SmartImage src={divImageWithBasePath0ImageSrc} alt={divImageWithBasePath0ImageAlt} className="img-fluid line-img" {...(divImageWithBasePath0ImageProps ?? {})} />
                ))}
            </div>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeFifteenAboutusSectionGenerated;
